(() => {
  "use strict";

  const mobileQuery = window.matchMedia("(max-width: 699px)");

  const getDetailsLabel = () => {
    return document
      .querySelector("[data-nfd-product-details-label]")
      ?.dataset.nfdProductDetailsLabel?.trim() || "View all product details";
  };

  const wrapSpecificationCard = (card) => {
    if (!card || card.closest(".nfd-product-details")) {
      return;
    }

    const details = document.createElement("details");
    const summary = document.createElement("summary");

    details.className = "nfd-product-details";
    details.open = !mobileQuery.matches;
    summary.textContent = getDetailsLabel();

    card.before(details);
    details.append(summary, card);
  };

  const initializeSpecificationCards = (root = document) => {
    root.querySelectorAll?.(".ndf-description .labelcard").forEach(wrapSpecificationCard);
  };

  const syncDetailsForViewport = () => {
    document.querySelectorAll(".nfd-product-details").forEach((details) => {
      details.open = !mobileQuery.matches;
    });
  };

  let stickyFrame;

  const syncStickyAfterDescription = () => {
    window.cancelAnimationFrame(stickyFrame);

    stickyFrame = window.requestAnimationFrame(() => {
      const stickyBar = document.querySelector("product-sticky-add-to-cart");

      if (!stickyBar) {
        return;
      }

      if (mobileQuery.matches) {
        stickyBar.classList.add("nfd-sticky-ready");

        const formId = stickyBar.getAttribute("main-product-form");
        const productForm = formId ? document.getElementById(formId) : null;
        const footer = document.querySelector(".shopify-section--footer");
        const purchaseAreaIsPast = productForm?.getBoundingClientRect().bottom < 0;
        const footerIsAhead = !footer || footer.getBoundingClientRect().top > window.innerHeight;

        stickyBar.classList.toggle(
          "nfd-mobile-sticky-visible",
          Boolean(purchaseAreaIsPast && footerIsAhead)
        );
        return;
      }

      stickyBar.classList.remove("nfd-mobile-sticky-visible");

      const description = document.querySelector(".ndf-description");

      if (!description) {
        stickyBar.classList.add("nfd-sticky-ready");
        return;
      }

      stickyBar.classList.toggle(
        "nfd-sticky-ready",
        description.getBoundingClientRect().bottom <= window.innerHeight - 120
      );
    });
  };

  document.addEventListener("click", (event) => {
    const notifyButton = event.target.closest("[data-nfd-sticky-notify]");

    if (!notifyButton) {
      return;
    }

    const notifyForm = document.querySelector("[data-nfd-back-in-stock]:not([hidden])");

    if (!notifyForm) {
      return;
    }

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    notifyForm.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "center" });

    window.setTimeout(() => {
      notifyForm.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    }, 450);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const target = mutation.target;

      if (target.nodeType === Node.ELEMENT_NODE) {
        if (target.matches?.(".ndf-description .labelcard")) {
          wrapSpecificationCard(target);
        }

        const parentCard = target.closest?.(".ndf-description .labelcard");

        if (parentCard) {
          wrapSpecificationCard(parentCard);
        }

        initializeSpecificationCards(target);
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return;
        }

        if (node.matches?.(".ndf-description .labelcard")) {
          wrapSpecificationCard(node);
        }

        initializeSpecificationCards(node);
      });

      syncStickyAfterDescription();
    });
  });

  initializeSpecificationCards();
  window.addEventListener("load", initializeSpecificationCards, { once: true });
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ["class"],
    childList: true,
    subtree: true,
  });
  window.addEventListener("scroll", syncStickyAfterDescription, { passive: true });
  window.addEventListener("resize", syncStickyAfterDescription, { passive: true });
  mobileQuery.addEventListener?.("change", () => {
    syncDetailsForViewport();
    syncStickyAfterDescription();
  });
  syncStickyAfterDescription();
})();
